import FieldsCollection from "../../../fields3/collection/base/fields-collection";
import {FieldType} from "../../../fields3/field-type";
import {EntityType} from "../../../gd/const/item";
import FieldDate from "../../../fields3/generic/datetime/date/date";
import Expense from "./expense";
import FieldProject from "../../../fields3/generic/entity/project/project";
import FieldUser from "../../../fields3/generic/user/user";
import FieldMoment from "../../../fields3/generic/datetime/moment/moment";
import FieldText from "../../../fields3/generic/text/text";
import FieldTask from "../../../fields3/generic/task/task";
import FieldExpenseApprovalStatus from "../../../fields3/system/expense/approval-status/approval-status";
import FieldExpenseReimbursement from "../../../fields3/system/expense/reimbursement/reimbursement";
import FieldConfig from "../../../fields3/proto/field-config";
import FieldProjectPath from "../../../fields3/generic/project-path/project-path";
import FieldAttachments from "../../../fields3/generic/attachments/attachments";
import FieldString from "../../../fields3/generic/string/string";
import {GroupedData} from "../../../data-structures/group";
import {SEPARATOR} from "../../../gd-components/popover-menu/const";
import FieldExpenseCategory from "../../../fields3/system/expense/expense-category/expense-category"
import FieldExpenseAmount from "../../../fields3/system/expense/amount/amount"
import FieldExpenseUnits from "../../../fields3/system/expense/units/amount"

export default class ExpenseFields extends FieldsCollection {


    constructor(options:any = {}) {

        // it should be inside constructor because it's using moment()
        const baseConfig : FieldConfig[] = [
            {
                fieldId             : 'name',
                label               : 'Expense name',
                type                : FieldType.STRING,
            },
            {
                fieldId             : 'projectId',
                label               : 'Project',
                type                : FieldType.EXPENSE_PROJECT,
                addNoValueOption    : false
            },
            {
                fieldId             : 'projectPath',
                label               : 'Project path',
                type                : FieldType.PROJECT_PATH,
                addNoValueOption    : false,
                maxParents          : 2
            },
            {
                fieldId             : 'amount',
                label               : 'Amount',
                type                : FieldType.EXPENSE_AMOUNT,
                defaultWidth        : 150,
            },
            {
                fieldId     : 'userId',
                label       : 'Submitted by',
                type        : FieldType.USER
            },
            {
                fieldId     : 'expenseCategoryId',
                label       : 'Expense Type',
                type        : FieldType.EXPENSE_CATEGORY
            },
            {
                fieldId         : 'comments',
                label           : 'Comments',
                type            : FieldType.TEXT
            },
            {
                fieldId         : 'expenseDate',
                label           : 'Date',
                maxDate         : moment(),
                type            : FieldType.DATE,
                defaultWidth    : 180,
            },
            {
                fieldId         : 'units',
                label           : 'Number of units',
                type            : FieldType.EXPENSE_UNITS,
            },
            {
                fieldId         : 'momentCreated',
                label           : 'Submitted on',
                type            : FieldType.MOMENT
            },
            {
                fieldId         : 'task',
                label           : 'Task',
                type            : FieldType.TASK,
                // defaultWidth    : 200,
            },
            {
                fieldId         : 'approvalStatus',
                label           : 'Approval status',
                type            : FieldType.EXPENSE_APPROVAL_STATUS,
                addNoValueOption: false,
                showMenuMore    : false,
                defaultWidth    : 180,
            },
            {
                fieldId         : 'reimbursementStatus',
                label           : 'Reimbursement',
                type            : FieldType.EXPENSE_REIMBURSEMENT
            },
            {
                fieldId         : 'attachments',
                label           : 'Attachments',
                type            : FieldType.ATTACHMENTS
            },
        ]

        super(baseConfig, EntityType.EXPENSE)
    }

    // Quick access

    get amount()                : FieldExpenseAmount { return this.get('amount') as FieldExpenseAmount }
    get expenseDate()           : FieldDate { return this.get('expenseDate') as FieldDate }
    get units()                 : FieldExpenseUnits { return this.get('units') as FieldExpenseUnits }
    get projectId()             : FieldProject { return this.get('projectId') as FieldProject }
    get projectPath()           : FieldProjectPath { return this.get('projectPath') as FieldProjectPath }
    get expenseCategoryId()     : FieldExpenseCategory { return this.get('expenseCategoryId') as FieldExpenseCategory }
    get userId()                : FieldUser { return this.get('userId') as FieldUser }
    get momentCreated()         : FieldMoment { return this.get('momentCreated') as FieldMoment }
    get comments()              : FieldText { return this.get('comments') as FieldText }
    get task()                  : FieldTask { return this.get('task') as FieldTask }
    //New fields
    get name()                  : FieldString { return this.get('name') as FieldString }
    get approvalStatus()        : FieldExpenseApprovalStatus { return this.get('approvalStatus') as FieldExpenseApprovalStatus }
    get reimbursementStatus()   : FieldExpenseReimbursement { return this.get('reimbursementStatus') as FieldExpenseReimbursement }
    get attachments()           : FieldAttachments { return this.get('attachments') as FieldAttachments }


    // Update isRequired based on the current model
    public updateRequiredFields(expense:Expense) {
        this.amount.isRequired  = expense.isAmountBased
    }


    // End Quick access

    // reset(options:any) {
    //     const {customFieldsIds} = options
    //
    //     const customFieldsConfig : any[] = []
    //     _.map(customFieldsIds, customFieldId=>{
    //         const field2Config = Field1ToField2Converter.getField2Config(customFieldId)
    //         if (field2Config) customFieldsConfig.push(field2Config)
    //     })
    //
    //     const fieldsConfig = _.union(baseConfig, customFieldsConfig)
    //
    //     this._fields = []
    //
    //     _.map(fieldsConfig, fieldConfig=>{
    //         this.addField(FieldsFactory.get(fieldConfig))
    //     })
    // }

    // getQuickFilterFields() {
    //     const quickFiltersOptions = [
    //         // add system fields manually to keep good order (!)
    //         { id: 'statusId',               label: 'Status'},
    //         { id: 'projectId',              label: 'Project'},
    //         { id: 'actionRequiredUserId',   label: 'Action required'},
    //         { id: 'assignedToUserId',       label: 'Assigned to'},
    //         { id: 'priority',               label: 'Priority'},
    //         { id: 'storyPoints',            label: 'Story points'},
    //         { id: 'taskTypeId',             label: 'Task type'},
    //     ]
    //
    //     // add custom fields available for quick filter (i.e. available to group by)
    //     _.map(this.customFields(), field=>{
    //         if (field.isGroupByAvailable)
    //             quickFiltersOptions.push({
    //                 id      : field.fieldId,
    //                 label   : field.label,
    //             })
    //     })
    //
    //     return quickFiltersOptions
    // }


    get structureConditions():GroupedData {

        // this.initAllCustomFields()
        //
        // const customFields : FieldProto[] = this.customFields()

        return [
            {
                value   : 'general',
                label   : 'General',
                type    : 'system',
                items   : [
                    this.name,
                    this.userId,
                    this.expenseCategoryId,
                    this.amount,
                    this.units,
                    SEPARATOR,
                    this.approvalStatus,
                    this.reimbursementStatus,
                    SEPARATOR,
                    this.comments,
                ]
            },
            {
                value   : 'dates',
                label   : 'Dates',
                type    : 'system',
                items   : [
                    this.momentCreated,
                    this.expenseDate,
                ]
            },
            {
                value   : 'parent',
                label   : 'Project',
                type    : 'system',
                items   : [
                    this.projectId,
                ]
            },
        ]
    }
}
